<template>
	<WebPlayer
		ref="webPlayer"
		:on-player-event="onPlayerEvent"
	>
		<WebPlayerFeedback
			ref="webPlayerFeedback"
			:on-submit-password="onSubmitPassword"
		/>
	</WebPlayer>
</template>

<script>
import WebPlayer from "lib/components/WebPlayer";
import WebPlayerFeedback from "lib/components/WebPlayerFeedback";

export default {
	name: "WebPlayerStream",
	components: {
		WebPlayer,
		WebPlayerFeedback
	},
	props: {
		onSubmitPassword: {
			type: Function,
			default: () => false,
			required: false
		},
		setupWait: {
			type: Number,
			default: 0,
			required: false
		},
		showUnavailable: {
			type: Boolean,
			default: true,
			required: false
		},
		stream: {
			required: true,
			validator: (prop) => prop instanceof Object || prop === null // custom validator since null is not a valid type
		}
	},
	created() {
		this.retrySetupTimer = null;
	},
	beforeDestroy () {
		clearTimeout(this.retrySetupTimer);
	},
	mounted() {
		if (this.stream) {
			this.setup();
		}
	},
	methods: {
		setup(wait = this.setupWait) {
			if (this.retrySetupTimer !== null)
				return;

			this.retrySetupTimer = setTimeout(() => {
				this.retrySetupTimer = null;

				this.$refs.webPlayer.setup({
					playlist: [{
						sources: [
							{ file: `https://${this.stream.server}/live/${this.stream.streamId}/master.m3u8` }
						],
						title: this.stream.title,
						withCredentials: true
					}]
				});
			}, wait);
		},
		onPlayerEvent(event) {
			switch (event.type) {

				case "buffer": {
					const provider = this.$refs.webPlayer.player.getProvider();

					if (provider.name === "shaka" && event.oldstate !== "playing")
						this.$refs.webPlayer.player.seek(-12);
					break;
				}

				case "error":
				case "warning":
					if (
						event.code !== 214000 &&
						event.code !== 220001 &&
						event.code !== 224002 &&
						event.code !== 224003 &&
						event.code !== 232404 &&
						event.code !== 232600 &&
						event.code !== 240000 &&
						event.code !== 241404 &&
						event.code !== 242601 &&
						event.code !== 340000
					)
						break;

					this.$refs.webPlayer.remove();
					this.setup(30000);

					if (!this.showUnavailable)
						break;

					this.$refs.webPlayerFeedback.show(false, this.stream.title, "The live stream is currently not available");
					break;

				case "firstFrame": {
					const textAlt = this.$el.querySelector(".jw-controls .jw-controlbar .jw-text-live");

					if (textAlt)
						textAlt.textContent = this.stream.title;
					break;
				}

				default:
					break;
			}
		}
	}
};
</script>
